  <!-- ********************** -->
<template>
  <div class=" bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="px-4">
      <div class="container mx-auto mt-4 mb-8">
        <div class="flex flex-wrap md:flex-nowrap gap-4">
          <div class=" text-md sm:text-lg">
            <p class="mb-4">
              An essential feature of any successful and profitable business is a
              robust and effective risk management programme.
            </p>
            <p>
              AXA believe that quality assurance forms the basis of successfully
              managing risk, and with our partners we are constantly working to
              provide innovative and bespoke risk management solutions for our
              clients within the motor fleet market.
            </p>
          </div>
          <div>
            <div
              class="px-4 sm:px-10 p-4 sm:p-8  bg-brand-taupe-700 rounded-lg font-callout text-xl sm:text-1xl font-medium text-white">
              According to statistical analysis, businesses that do not engage in a
              risk management process have, on average, a worse claims experience than
              those business that do participate.
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-16 pb-16 mx-auto">
        <div class="flex justify-center">
          <StartReviewButton>
            Start your review today
          </StartReviewButton>
        </div>
      </div>
    </div>
	<div class="hidden border-1 border-red-500"></div>
	<div class="hidden border-1 border-green-500"></div>
	<div class="hidden border-1 border-amber-500"></div>
	<div class="hidden border-1 brand-grey-500"></div>
  </div>
</template>

<script>
import PageHeader from "../Shared/PageHeader";
import StartReviewButton from "../Shared/StartReviewButton.vue"

export default {
  components: {
    PageHeader,
    StartReviewButton
  },
  data: function () {
    return {
      show: true,
      headingContent: {
        hero: {
          image: '/images/254411986_car_hero.jpg',
          title: 'Fleet Risk Review',
          subtitle: 'In association with AXA Insurance',
        },
        page: {
          title: 'Fleet Risk Review',
          subtitle: '',
        },
      }
    }
  },
};
// Alternative layout
// import Layout2 from "../Shared/Layout.vue";

// export default {
//   layout: Layout2,
// };
</script>
